exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host{\r\n  background: #007b85;\r\n  color: #fff;\r\n  position: fixed;\r\n  left: 0;\r\n  right: auto;\r\n  bottom: 0;\r\n  top:0px;\r\n  width: 15%;\r\n  min-width: 150px;\r\n  z-index: 9999;\r\n  font-family: Arial, \"Helvetica Neue\", Helvetica, sans-serif;\r\n}\r\n\r\nul {\r\n  font-size: 18px;\r\n  line-height: 3;\r\n  font-weight: 400;\r\n  padding-top: 65px;\r\n  list-style: none;\r\n\r\n}\r\n.flex-column{\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-direction: column;\r\n      flex-direction: column;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/menu/menu.component.css
// module id = 469
// module chunks = 1